<template>
  <div class="tla-form-group tla-form-group--margin-medium" v-if="!isHidden">
    <label class="tla-form-group__label tla-form-group__label--required" v-html="newUsedVehicleLabel"></label>

    <div class="tla-form-group__touch-points">
      <touchpoint v-for="(item) in options"
        :key="item.touchpointValue"
        :collectionName="'newUsedVehicle'"
        :inputId="item.touchpointValue"
        :inputValue="item.touchpointValue"
        :isFullWidth="true"
        :isSelected="item.preSelect"
        :validationScope="validationScope"
        :validationRules="validationRules"
        @newUsedVehicle="submitVehicleCondition($event)">
        <touchpointText slot="touchpoint" :content="item.touchpointName"></touchpointText>
      </touchpoint>
    </div>
    <span class="tla-form-group__message" :class="getValidationClass('newUsedVehicle', 'message')">
      Please select an option.
    </span>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import {
  namespace
} from 'vuex-class';
import { Component, Prop, Inject } from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import { validationService } from '@/services/ValidationService';
import Touchpoint from '../../models/Touchpoint';
import GenericTouchPointComponent from '../ui/GenericTouchPointComponent.vue';
import VehicleCondition from '../../enums/VehicleCondition';
import ExtraData from '../../models/ExtraData';
import GenericTouchPointTextComponent from '../ui/GenericTouchPointTextComponent.vue';

const EnquiryModule = namespace('enquiryModule');

@Component({
  components: {
  touchpoint: GenericTouchPointComponent,
  touchpointText: GenericTouchPointTextComponent
  }
  })
export default class NewUsedVehicleComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: 'Are you considering new or used? <span>*</span>' })
  public newUsedVehicleLabel! : string;

  @Prop({ default: null })
  public validationScope!: string;

  @Prop({ default: false })
  public preSelectValue!: boolean;

  @Prop({ default: false })
  public isHidden!: boolean;

  public get validationRules(): string {
    return this.preSelectValue ? '' : 'required';
  }

  public options: Touchpoint[] = [
    new Touchpoint(`${VehicleCondition.New}`, 'New', this.preSelectValue),
    new Touchpoint(`${VehicleCondition.Used}`, 'Used'),
    new Touchpoint(`${VehicleCondition.Both}`, 'Considering Both')
  ];

  public submitVehicleCondition(condition: string) {
    const extraData: ExtraData = new ExtraData('newUsedVehicle', `${VehicleCondition[condition]}`);
    this.$store.dispatch('enquiryModule/submitExtraData', extraData);
  }

  public getValidationClass(fieldName: string, fieldType: string) {
    return validationService
      .getValidationClass(this.$validator, fieldName, fieldType, false, false, this.validationScope);
  }

  public created() {
    if (this.preSelectValue) {
      this.submitVehicleCondition(`${VehicleCondition.New}`);
    }
  }
}
</script>
